export const USER_AFTER_LOGIN = 'USER_AFTER_LOGIN';
export const USER_AFTER_LOGIN_SUCCESS = 'USER_AFTER_LOGIN_SUCCESS';
export const USER_TOKEN = 'USER_TOKEN';

export const USER_PAGE = 'USER_PAGE';
export const USER_PAGE_SUCCESS = 'USER_PAGE_SUCCESS';
export const USER_STORE = 'USER_STORE';
export const USER_STORE_SUCCESS = 'USER_STORE_SUCCESS';
export const USER_UPDATE = 'USER_UPDATE';
